/** Normalize role key for comparisons (super_admin, super admin → superadmin). */
export const normalizeRoleKey = (roleName) =>
  (roleName || "").toString().trim().toLowerCase().replace(/[_\s]+/g, "");

export const isSuperAdminRole = (roleName) => normalizeRoleKey(roleName) === "superadmin";
